import React, { useState } from 'react';
import { defalutModalContentProps } from '@components/Modal/ModalProvider';
import { ICON_MAP } from '@components/Icons/Icons';
import styles from './EditModelContent.module.scss';
import Radio from '@components/Radio';
import { ReactComponent as WarningIcon } from 'img/triangle-exclamation.svg';
import { EditTarget } from 'config/analysisConfig';


interface EditOption {
  value: EditTarget;
  title: string;
  description: string;
}

interface Props extends defalutModalContentProps {
  editOptions: EditOption[];
  title: string;
  editQuestion: string;
  warningMessage: string;
  isApplyDisabled?: boolean;
  selectedTargetDefault?: EditTarget;
  onApply?: (target: EditTarget) => void;
}
const EditModelContent: React.FC<Props> = ({
  close,
  editOptions,
  title,
  editQuestion,
  warningMessage,
  isApplyDisabled = false,
  selectedTargetDefault = null,
  onApply,
}) => {
  const [selectedTarget, setSelectedTarget] = useState<EditTarget>(
    selectedTargetDefault,
  );
  const CloseIcon = ICON_MAP['close'];

  return (
    <div className={styles.controller}>
      <div className={styles.header}>
        <span className={styles['text-bold-sm']}>{title}</span>
        <button type="button" className={styles.closeButton} onClick={close}>
          <CloseIcon />
        </button>
      </div>

      <div className={styles.contents}>
        <div className={styles.content}>
          <span className={styles['text-sm']}>{editQuestion}</span>

          <div className={styles.options}>
            {editOptions.map(({ value, title, description }) => (
              <label
                key={value}
                className={`${styles.option} ${
                  selectedTarget === value ? styles.selected : ''
                }`}
              >
                <Radio
                  onChange={() => {
                    setSelectedTarget(value);
                  }}
                  checked={selectedTarget === value}
                  value={value}
                />

                <div className={styles.optionText}>
                  <span className={styles['text-bold-sm']}>{title}</span>
                  <span
                    className={`${styles['text-sm']} ${styles['text-dimmed']}`}
                  >
                    {description}
                  </span>
                </div>
              </label>
            ))}
          </div>

          {selectedTarget && (
            <div className={styles.warning}>
              <WarningIcon className={styles.warningIcon} />

              <span>{warningMessage}</span>
            </div>
          )}
        </div>
      </div>

      <div className={styles.ModelActions}>
        <button type="button" className={styles.cancelButton} onClick={close}>
          Cancel
        </button>
        <button
          type="button"
          className={styles.applyButton}
          disabled={isApplyDisabled}
          onClick={() => {
            onApply?.(selectedTarget);
          }}
        >
          Apply Changes
        </button>
      </div>
    </div>
  );
};

export default EditModelContent;
